import { createLocation } from 'history';
export var resolveToLocation = function (to, currentLocation) {
  return typeof to === 'function' ? to(currentLocation) : to;
};
export var normalizeToLocation = function (to, currentLocation) {
  return typeof to === 'string' ? createLocation(to, null, null, currentLocation) : to;
};